<template>
    <div>
        <v-dialog v-model="dialog_select_ledger" no-click-animation persistent scrollable max-width="400" content-class="full-height" lazy transition="dialog-bottom-transition">
            <v-card flat>
                <v-toolbar flat fixed>
                    <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                    <v-toolbar-title>Select Ledger</v-toolbar-title>
                    <v-text-field v-if="type=='others'" slot="extension" hide-details clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch"></v-text-field>
                </v-toolbar>


                <v-card-text full-height nopadding id="scrollable-div">

                    <v-list nopadding>
                        <v-list-item v-for="(item, index) in ledgers" :key="index" @click="fn_selectItem(item)">
                            <v-list-item-content>
                                <v-list-item-title>{{ item.accountLedgerName }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon>{{ selectedItem && selectedItem.accountLedgerId == item.accountLedgerId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
            
                </v-card-text>

            </v-card>
          </v-dialog>

    
    </div>
</template>

<script>

const transactionTypes = require('../../../../config.js').configs.transactionTypes;
const paymentAccountsAndLedger = require('../../../../config.js').configs.paymentAccountsAndLedger;

export default{
    props:['type', 'transactionTypeId', 'savePaymentMode'],
    data(){
        return{
            dialog_select_ledger: false,
            selectedItem:null,
            ledgers:[],
            timeoutid:null,
            searchValue:''
        }
    },
    methods:{
        openDialogWeb: function () {
            this.dialog_select_ledger = true;
            if(this.type=='duties_and_taxes'){
                this.fn_getDutiesAndTaxesAccounts();
            }
            else{
                this.fn_getOtherAccounts();
            }
        },
        closeDialogWeb: function () {
            this.dialog_select_ledger = false;
        },
        fn_debounceSearch: function(){
             if (this.timeoutid != null){
                clearTimeout(this.timeoutid);
             }

            this.timeoutid = setTimeout(() => { 
                this.fn_getOtherAccounts();
            },100);
        },
        fn_getDutiesAndTaxesAccounts: function () {
            let filterObject = {};
            if(this.transactionTypeId == transactionTypes.receipt.id || this.transactionTypeId == transactionTypes.payment.id || this.settings.transactionTypeId == transactionTypes.contra.id){
                filterObject.accountGroups = [paymentAccountsAndLedger.groups.dutiesAndTaxes];	
            }

            let self = this;
            this.getFilterData('PaymentGroups', null, filterObject, null,
                {
                    onSuccess: function(response){
                        console.log(response);
                        let data = JSON.parse(response);
                        if(data && data.length && data[0].accountLedgers){
                            self.ledgers = data[0].accountLedgers;
                        }
                        else{
                            self.ledgers = [];
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
        fn_getOtherAccounts: function () {
            let filterObject = {};
            if(this.transactionTypeId == transactionTypes.receipt.id || this.transactionTypeId == transactionTypes.payment.id || this.settings.transactionTypeId == transactionTypes.contra.id){
                filterObject.accountGroups = [paymentAccountsAndLedger.groups.cashInHand, paymentAccountsAndLedger.groups.bank, paymentAccountsAndLedger.groups.card, paymentAccountsAndLedger.groups.wallet, paymentAccountsAndLedger.groups.dutiesAndTaxes];	
            }

            filterObject.startIndex = 0;
            filterObject.limit = 100;
            filterObject.search = this.searchValue;
            let self = this;
            this.getFilterData('AllGroupLedgers', null, filterObject, null,
                {
                    onSuccess: function(response){
                        console.log(response);
                        let data = JSON.parse(response);
                        if(data && data.items && data.items.length){
                            self.ledgers = data.items;
                        }
                        else{
                            self.ledgers = [];
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },
        fn_selectItem: function(item){
            this.selectedItem = item;
            this.selectedItem.type = this.type;
            this.savePaymentMode(this.selectedItem, this.type, true);
        },
        fn_selectAddress: function(addressObj){
            let itemIndex = this.addresses.findIndex(address=>{
                return addressObj.addressId == address.addressId;
            }) 
            for(let i=0; i<this.addresses.length; i++){
                if(this.addresses[i].groupTypeId == 102){
                    this.addresses[i].isDefault = false;
                }
            }
            this.addresses[itemIndex].isDefault = true;
            this.selectedItemIndex = itemIndex;
        },
        fn_doneSelection: function(){
            for(let i=0; i<this.$parent.Form.partyDetails.addresses.length; i++){
                if(this.$parent.Form.partyDetails.addresses[i].groupTypeId == 102){
                    this.$parent.Form.partyDetails.addresses[i].isDefault = false;
                }                
            }
            this.$parent.Form.partyDetails.addresses[this.selectedItemIndex].isDefault = true;
            this.$parent.Form.addresses = this.$parent.Form.partyDetails.addresses.filter(address=>{
                return address.isDefault;
            })
            this.fn_closeDialog();
        },
        fn_closeDialog: function(){
            if(this.$parent.fn_closeDialog){
                this.$parent.fn_closeDialog();
            }
            else{
                this.closeDialogWeb();
            }
        }
    }
}
</script>